<template>
  <device-statistics-analogue-chart :chart-data="chartData"
                                    :options="options"
                                    :height="250"/>
</template>

<script>
import moment from 'moment'
import DeviceStatisticsAnalogueChart from './device-statistics-analogue-chart'

export const round = value => {
  if (Number.isNaN(Number(value))) {
    return value
  }
  return Number(Number(value).toPrecision(6))
}

export default {
  components: {
    DeviceStatisticsAnalogueChart
  },
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  computed: {
    values () {
      return this.data.map(([value, stat]) => value)
    },
    stats () {
      return this.data.map(([value, stat]) => stat)
    },
    chartData () {
      const { values, stats } = this
      const datasets = [{
        backgroundColor: 'rgba(54, 162, 235, 0.08)',
        borderColor: 'rgba(54, 162, 235, 1)',
        hoverBackgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderWidth: 1,
        data: stats
          .map(({ percentTime }) => Math.round(percentTime * 1000) / 10)
      }]
      return {
        labels: values.map(round),
        datasets
      }
    },
    options () {
      const { stats } = this
      return {
        plugins: {
          datalabels: {
            display: false
          }
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        tooltips: {
          callbacks: {
            label (tooltipItem) {
              const stat = stats[tooltipItem.index]
              return tooltipItem.value + '% (' + moment.duration(Number(stat.sumTime)).format() + ')'
            }
          }
        }
      }
    }
  }
}
</script>
